import MyProfile from "../../../jsx/components/Dashboard/MyProfile/myprofile";

const MyProfileWrapper = () => {
  return <MyProfile />;
};

export const allowedRoles = [
  _enum.ROUTE_PERSONAS.connector,
  _enum.ROUTE_PERSONAS.associate,
  _enum.ROUTE_PERSONAS.manager,
];

export default constore(MyProfileWrapper);
